import * as actionTypes from "./page-filter.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET,
  });
};

export const setFilter = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_FILTER,
    payload: data,
  });
};
